import { render } from "./SetUserInfo.vue?vue&type=template&id=c060cd9c&scoped=true"
import script from "./SetUserInfo.vue?vue&type=script&lang=js"
export * from "./SetUserInfo.vue?vue&type=script&lang=js"

import "./SetUserInfo.vue?vue&type=style&index=0&id=c060cd9c&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c060cd9c"]])

export default __exports__